import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const currentYear = dayjs().year();
const currentYearShort = currentYear.toString().slice(-2);

const initialState = {
  startDate: null,
  endDate: null,
  selectedPeriod: "ytd",
  selectedPropertyId: "",
  selectedEntityType: "property",
  selectedPropertyGroupId: "",
};

export const pnlFilterSlice = createSlice({
  name: "pnlFilter",
  initialState,
  reducers: {
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setSelectedPeriod: (state, action) => {
      state.selectedPeriod = action.payload;
    },
    setSelectedPropertyId: (state, action) => {
      state.selectedPropertyId = action.payload;
    },
    setSelectedEntityType: (state, action) => {
      state.selectedEntityType = action.payload;
    },
    setSelectedPropertyGroupId: (state, action) => {
      state.selectedPropertyGroupId = action.payload;
    },
    resetPnlFilters: (state) => {
      return { ...initialState };
    },
  },
});

export const {
  setStartDate,
  setEndDate,
  setSelectedPeriod,
  setSelectedPropertyId,
  setSelectedEntityType,
  setSelectedPropertyGroupId,
  resetPnlFilters,
} = pnlFilterSlice.actions;

export default pnlFilterSlice.reducer;
